export const SERVICES = [
  {
    slug: "digital-marketing",
    title: "Digital Marketing",
    icon: "megaphone",
    short: "SEO, PPC, content and social media strategies that grow revenue.",
    long: "We offer top-of-the-line project management services. Our team leverages cutting-edge strategies in SEO, PPC, content marketing and social media to enhance your online visibility and engagement.",
    image: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Search Engine Optimization", "Pay-per-Click Campaigns", "Content Marketing", "Analytics & Reporting"],
  },
  {
    slug: "website-design",
    title: "Website Design",
    icon: "monitor",
    short: "Beautiful, bilingual, SEO-friendly websites that convert.",
    long: "We design websites that blend creativity, functionality, and bilingual communication. From responsive layouts to SEO-friendly structures, our web solutions are crafted to help businesses grow digitally. We specialise in professional documentation, e-commerce integration, and dynamic content management systems.",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Responsive Design", "E-commerce", "CMS Integration", "Ongoing Maintenance"],
  },
  {
    slug: "it-project-management",
    title: "IT Project Management",
    icon: "kanban",
    short: "Plan, execute and deliver your project on time and within budget.",
    long: "We tailor our approach to meet your unique business needs, ensuring maximum ROI and sustainable growth. Partner with us to transform your digital presence and achieve your marketing goals.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Agile Delivery", "Vendor Management", "Risk & QA", "Post-launch Support"],
  },
  {
    slug: "social-media-management",
    title: "Social Media Management",
    icon: "share-2",
    short: "Content, campaigns and community on Instagram, LinkedIn & more.",
    long: "We create engaging content and targeted campaigns across platforms like Facebook, Instagram, LinkedIn, and Twitter to connect with your audience, drive traffic and boost conversions.",
    image: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Content Calendars", "Paid Ads", "Influencer Outreach", "Reels & Shorts"],
  },
  {
    slug: "graphic-design",
    title: "Graphic Design",
    icon: "palette",
    short: "Flyers, invitations, brand kits, video creatives and more.",
    long: "We offer a wide range of graphic design services, including digital flyers, invitation cards, video creation and brand promotion. Every piece is crafted to make your brand memorable.",
    image: "https://images.unsplash.com/photo-1626785774573-4b799315345d?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Brand Identity", "Print & Digital Flyers", "Motion Graphics", "Social Templates"],
  },
  {
    slug: "it-consulting",
    title: "IT Consultant & Counselling",
    icon: "lightbulb",
    short: "Cutting-edge IT consulting that drives innovation and efficiency.",
    long: "We provide cutting-edge IT business consulting and counselling services designed to drive innovation, efficiency and growth for your business. Our expert team helps you optimize technology, enhance operational efficiency and stay ahead of the competition.",
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Tech Strategy", "Cloud & Networking", "Cyber Security", "Career Counselling"],
  },
  {
    slug: "it-security-services",
    title: "IT Security Services",
    icon: "shield",
    short: "Cyber-security, CCTV surveillance and network protection.",
    long: "Protect your home or business with professional IT security services. From HD surveillance cameras with night vision and real-time mobile access, to network firewalls, cyber-security audits and secure infrastructure — our systems ensure that you always stay in control. We combine physical security (CCTV, access control) with digital security (firewalls, endpoint protection, cyber-security consulting) to give you a complete shield.",
    image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?q=80&w=1600&auto=format&fit=crop",
    bullets: ["CCTV & HD/4K Cameras", "Network & Firewall Protection", "Cyber-security Consulting", "24/7 Support & Monitoring"],
  },
  {
    slug: "computer-education",
    title: "Computer Education & Training",
    icon: "graduation-cap",
    short: "Affordable, job-oriented computer courses.",
    long: "We provide practical computer training courses with features of affordable cost, time-saving delivery, experienced faculty, career building and job orientation.",
    image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=1600&auto=format&fit=crop",
    bullets: ["Basic to Advanced", "Certified Faculty", "Placement Support", "Live Projects"],
  },
];

// Fallback client/partner data (Home fetches live from /api/logos; these are only used if API fails)
export const PARTNERS = [
  { name: "TATA Tele Business Services", src: "/logos/partner/tata-tele.jpg" },
  { name: "CP Plus", src: "/logos/partner/cp-plus.jpg" },
  { name: "Geonix", src: "/logos/partner/geonix.jpg" },
  { name: "Vyapar", src: "/logos/partner/vyapar.jpg" },
  { name: "Seagate", src: "/logos/partner/seagate.jpg" },
];

export const CLIENTS = [
  { name: "House of Amritsar", src: "/logos/client/house-of-amritsar.jpg" },
  { name: "Hotel Le Icon", src: "/logos/client/hotel-le-icon.jpg" },
];

export const CONTACT = {
  phone1: "+91 98087 24448",
  phone2: "0135-355 8143",
  email: "hubdigisolution@gmail.com",
  address: "Digi Hub Solution, Gali no 11, Devender Vihar, Gumaniwala, Haridwar Bypass Road, Rishikesh, Uttarakhand 249204",
  hours: [
    { day: "Monday – Friday", time: "9 AM – 8 PM" },
    { day: "Saturday", time: "10 AM – 6 PM" },
    { day: "Sunday", time: "10 AM – 2 PM" },
  ],
  whatsapp: "919808724448",
  whatsappMessage: "Hi, I'm interested in your services at Digi Hub Solution.",
  socials: {
    facebook: "https://facebook.com/hubdigisolution",
    instagram: "https://instagram.com/hubdigisolution",
    linkedin: "https://in.linkedin.com/company/digi-hub-solution",
  },
};
